import { FlatButton, Paper } from "material-ui";
import { NavigationArrowBack } from "material-ui/svg-icons";
import React from "react";
import { FormattedMessage } from "react-intl";
import * as moment from "moment";
import config from "../../config/config";
import { getProblemTypeTranslation } from "./ProblemReportsTable";

class ProblemReportsDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      report: {},
    };
  }

  componentDidMount() {
    this.props.location.state && this.props.location.state.report
      ? this.setState({ report: this.props.location.state.report })
      : this.props.history.goBack();
  }

  getAttachmentURL =  (url) => {
    const imageParts = url.split("/");
    return `${config.URI}/api/v1/get_report_image?file_name=${imageParts[imageParts.length - 1]}`
  };



  render() {
    return (
      <Paper
        style={{
          borderRight: "2px solid #e3e3e3",
          padding: "10px 16px",
          margin: "10px",
        }}
      >
        <div
          style={{
            fontSize: "16px",
            marginBottom: "16px",
          }}
        >
          <div>
            <FlatButton
              onClick={() => this.props.history.goBack()}
              icon={
                <NavigationArrowBack
                  color="#3659A0"
                  style={{ marginLeft: 0 }}
                />
              }
              label={<FormattedMessage id="transcriptions.back" />}
              labelStyle={{
                color: "#3659A0",
              }}
              style={{
                marginBottom: "5px",
              }}
            />
          </div>
          <div style={{ marginTop: "20px", marginBottom: '10px' }}>
            <div className="report-detail-container">
              <div className="report-details-heading">
                <FormattedMessage id="problemReport.domainName" />
              </div>
              <div className="report-details">{this.state.report.room}</div>
            </div>
            <div className="report-detail-container">
              <div className="report-details-heading">
                <FormattedMessage id="problemReport.date" />
              </div>
              <div className="report-details">
                {moment(this.state.report.created_at).format("YYYY-MM-DD HH:mm:ss")}
              </div>
            </div>
            <div className="report-detail-container">
              <div className="report-details-heading">
                <FormattedMessage id="problemReport.problemType" />
              </div>
              <div className="report-details">
                {getProblemTypeTranslation(this.state.report.problem_in)}
              </div>
            </div>
            <div className="report-detail-container">
              <div className="report-details-heading">
                <FormattedMessage id="problemReport.description" />
              </div>
              <div className="report-details">{this.state.report.details}</div>
            </div>
          </div>

          {this.state.report &&
            this.state.report.image &&
            this.state.report.image.url && (
              <a
                href={this.getAttachmentURL(this.state.report.image.url)}
                id="report-download"
                style={{ marginTop: "10px", cursor: 'pointer', textDecoration: 'underline', color: '#000' }}
                target="_blank"
              >
                <FormattedMessage id="problemReport.downloadAttachment" />
              </a>
            )}
        </div>
      </Paper>
    );
  }
}

export default ProblemReportsDetails;



// WEBPACK FOOTER //
// src/routes/ProblemReports/ProblemReportsDetails.js